module.exports = __webpack_public_path__ + "img/ico_main_new.df3c2b6b.svg";